import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-637d24b7")

_pushScopeId("data-v-637d24b7")
const _hoisted_1 = { class: "shopping-category-list" }
const _hoisted_2 = { class: "shopping-category-list-noelement-content" }
const _hoisted_3 = { class: "shopping-category-list-noelement-content-text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ShoppingCategoryListItem = _resolveComponent("ShoppingCategoryListItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getCategoryList(), (category) => {
      return (_openBlock(), _createBlock(_component_ShoppingCategoryListItem, {
        key: category.categoryName,
        categoryName: category.categoryName,
        foodList: category.foodList,
        onCheckClick: _ctx.checkClick,
        onEditClick: _ctx.editClick
      }, null, 8, ["categoryName", "foodList", "onCheckClick", "onEditClick"]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createVNode("div", {
      class: "shopping-category-list-noelement",
      style: _ctx.styleNoElement
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode("span", _hoisted_3, _toDisplayString(_ctx.noElementMessage), 1)
      ])
    ], 4)
  ]))
})